import React, {useEffect, useState} from "react";

import {magazineTypes} from "../../pages/magazine/MagazineList";
import FileManagerSelector from "../../pages/fileManager2/selector/FileManagerSelector";
import {FileManagerTypes} from "../fileManager/FileManager";
import VideoPlayer from "../players/videoPlayer/VideoPlayer";
import videoType from "../../raikoComponents/raikoEditor/image/video-type.svg";
import {HttpClient} from "../../service/httpClient/HttpClient";
import {MagazineService} from "../../serverService/magazineService/MagazineService";
import {LoadingHelper} from "../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../context/LoadingContext";
import AudioPlayer from "../players/audioPlayer/AudioPlayer";
import audioType from "../../raikoComponents/raikoEditor/image/music-type.svg";
import "./NewsDetailCornerstone.scss"
import {css} from "@emotion/css";
import {
    DialogSize,
    RaikoBaseCardContainer,
    RaikoDefaultDialogPage,
    RaikoDivider,
    RaikoGridOneColumn,
    RaikoMaterialOutlinedInput,
    RaikoSectionContainer,
    RaikoSimpleMultiLineInputOutlined,
    showErrorMessage,
    showSuccessMessage,
    showWarningMessage
} from "@moeindal/base-raiko-panel-components";
import {detectServerErrorMessage} from "../../util/detectServerErrorMessage";

export default function NewsDetailCornerstone({type, blogID}) {

    const service = new MagazineService()
    const loading = new LoadingHelper(useLoadingDispatcher())


    const [url, setUrl] = useState("");
    const [id, setId] = useState(-1);

    const [galleryDialogOpenState, setGalleryDialogOpenState] = useState(false)

    const [title, setTitle] = useState("");
    const [description, setDescription] = useState("");

    useEffect(() => {
        if (typeof id !== "undefined" && id >= 0) {
            new HttpClient()
                .get(
                    `files/${id}/urls/public`
                ).then(response => {
                setUrl(response.streamUrl.replaceAll("http:", "https:"))
            }).catch(reason => {
                console.log("image not loading by reason ", reason)
            })
        } else {
            setUrl("")
        }
    }, [id])

    useEffect(() => {
        if (typeof service !== 'undefined') {

            service.getCornerstone(blogID)
                .then(response => {
                    if (response.content) {
                        setId(response.content.id)
                        setTitle(response.content.title)
                        setDescription(response.content.description)
                    }
                }).catch(reason => {
                showErrorMessage(detectServerErrorMessage(reason))
            }).finally(_ => {

            })

        }
    }, [blogID])


    function handleSelectVideo(id, url) {
        setId(id)
    }

    function handleOpenFileManager() {
        setGalleryDialogOpenState(true)
    }

    function handleUpdateVideo() {
        if (checkFields()) {
            loading.show()
            const _type = type === magazineTypes.VIDEO.id ?
                "INTERNAL_VIDEO" : "INTERNAL_SOUND"

            service.updateCornerstone(
                blogID,
                id,
                title,
                description,
                _type
            ).then(response => {
                showSuccessMessage("بروزرسانی با موفقیت انجام شد.")
            }).catch(reason => {
                showErrorMessage(detectServerErrorMessage(reason))
            }).finally(_ => {
                loading.hide()
            })

        }
    }

    function checkFields() {
        let state = false
        let message = ""

        if (id === -1) {
            message = "لطفا محتوای شاخص خود را انتخاب نمایید."
        } else
            state = true

        if (message && message.length > 0)
            showWarningMessage(message)


        return state
    }

    return (
        <>
            <RaikoDefaultDialogPage
                onClose={_ => {
                    setGalleryDialogOpenState(false)
                }}
                open={galleryDialogOpenState}
                dialogSize={DialogSize.LARGE}
                pageTitle={"ویدیو مورد نظر خود را انتخاب نمایید."}
            >
                <FileManagerSelector
                    setOpenDialog={setGalleryDialogOpenState}
                    bucketId={type === magazineTypes.VIDEO.id ? FileManagerTypes.POST_VIDEOS.id : FileManagerTypes.POST_AUDIOS.id}
                    setSelectedFileUrl={handleSelectVideo}
                />

            </RaikoDefaultDialogPage>
            {
                type === magazineTypes.VIDEO.id ?
                    <RaikoBaseCardContainer>
                        <RaikoSectionContainer
                            title={"ویدیو شاخص"}
                            subTitle={"محتوایی که به عنوان محتوای اصلی در بالای صفحه قرار می گیرد."}
                            hasActionButton
                            actionButtonOnclick={handleUpdateVideo}
                        >
                            <RaikoGridOneColumn className={"cornerstoneContainer"}>
                                {url && url.length > 0 ?
                                    <RaikoGridOneColumn className={"videoSelectorPreviewContainer"}>
                                        <VideoPlayer file={url}/>
                                        <span onClick={handleOpenFileManager}>برای تغییر ویدیو اینجا کلیک نمایید</span>
                                    </RaikoGridOneColumn> :
                                    <div
                                        className={"videoNotSelectedContainer"}
                                        onClick={handleOpenFileManager}
                                    >

                                        <img src={videoType} alt=""/>
                                        <span>برای انتخاب ویدیو کلیک نمایید.</span>
                                    </div>
                                }
                                <RaikoDivider/>
                                <RaikoMaterialOutlinedInput
                                    labelText={"عنوان"}
                                    className={css`width: 100%;`}
                                    value={title}
                                    setValue={setTitle}
                                />
                                <RaikoSimpleMultiLineInputOutlined
                                    labelText={"توضیحات"}
                                    setValue={setDescription}
                                    value={description}
                                />
                            </RaikoGridOneColumn>
                        </RaikoSectionContainer>
                    </RaikoBaseCardContainer> :
                    type === magazineTypes.PODCAST.id ?
                        <RaikoBaseCardContainer>
                            <RaikoSectionContainer
                                title={"صوت شاخص"}
                                subTitle={"محتوایی که به عنوان محتوای اصلی در بالای صفحه قرار می گیرد."}
                                hasActionButton
                                actionButtonOnclick={handleUpdateVideo}
                            >
                                <RaikoGridOneColumn className={"cornerstoneContainer"}>
                                    {url && url.length > 0 ?
                                        <RaikoGridOneColumn className={"videoSelectorPreviewContainer"}>
                                            <AudioPlayer url={url}/>
                                            <span
                                                onClick={handleOpenFileManager}>برای تغییر صوت اینجا کلیک نمایید</span>
                                        </RaikoGridOneColumn> :
                                        <div
                                            className={"videoNotSelectedContainer"}
                                            onClick={handleOpenFileManager}
                                        >

                                            <img src={audioType} alt=""/>
                                            <span>برای انتخاب صوت کلیک نمایید.</span>
                                        </div>
                                    }
                                    <RaikoDivider/>
                                    <RaikoMaterialOutlinedInput
                                        labelText={"عنوان"}
                                        className={css`width: 100%;`}
                                        value={title}
                                        setValue={setTitle}
                                    />
                                    <RaikoSimpleMultiLineInputOutlined
                                        labelText={"توضیحات"}
                                        setValue={setDescription}
                                        value={description}
                                    />
                                </RaikoGridOneColumn>
                            </RaikoSectionContainer>
                        </RaikoBaseCardContainer> :
                        ""
            }

        </>


    )
}
